export const ReplayIcon = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    color='red'
  >
    <path
      d='M11.9584 3.40375C11.3907 2.62027 10.6453 1.98257 9.78339 1.543C8.92148 1.10342 7.96761 0.874491 7.00007 0.875001C3.83432 0.875001 1.23091 3.27542 0.908323 6.356L0.847656 6.93583L2.00849 7.05775L2.06857 6.47733C2.17722 5.45056 2.60366 4.4833 3.2884 3.7105C3.97314 2.93771 4.88203 2.39792 5.88826 2.16645C6.89449 1.93498 7.94788 2.02337 8.90146 2.41928C9.85505 2.8152 10.6613 3.4989 11.2077 4.375H9.04174V5.54167H13.1251V1.45833H11.9584V3.40375ZM11.9917 6.94225L11.931 7.52267C11.8222 8.54928 11.3957 9.51635 10.711 10.289C10.0263 11.0616 9.11754 11.6013 8.11146 11.8327C7.10538 12.0642 6.05214 11.9759 5.09865 11.5801C4.14516 11.1843 3.33896 10.5009 2.79249 9.625H4.95841V8.45833H0.875073V12.5417H2.04174V10.5963C2.60944 11.3797 3.35484 12.0174 4.21675 12.457C5.07867 12.8966 6.03254 13.1255 7.00007 13.125C10.1652 13.125 12.7692 10.7246 13.0912 7.644L13.1519 7.06417L11.9917 6.94225Z'
      fill='#b7870c'
    />
  </svg>
)
